export function formatPublicUserId(userId) {
  if (userId === undefined || userId === null || userId === "") {
    return "";
  }

  const sequence = String(userId).padStart(6, "0");
  return `GW-U-${sequence}`;
}
